import { render, staticRenderFns } from "./managerList.vue?vue&type=template&id=248b76bc&scoped=true&"
import script from "./managerList.vue?vue&type=script&lang=js&"
export * from "./managerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b76bc",
  null
  
)

export default component.exports